<template>
  <el-dialog
    title="自动化生成台账"
    :visible.sync="show"
    width="40%"
    :before-close="handleClose"
    :close-on-click-modal='false'
    :close-on-press-escape='false'
  >
    <div class="dialog-box">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="评估类型:">
          <el-radio-group
            v-model="ruleForm.assessType"
            style="width:90%"
            @change="assessTypeChange"
          >
            <el-radio
              style="width:40%"
              v-for="(item, index) in assessmentType"
              :label="item.id"
              :key="index"
              >{{ item.name }}
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="风险类型:">
          <el-radio-group
            v-model="riskTypeId"
            v-if="ruleForm.assessType == 0"
            style="width:90%"
          >
            <el-radio
              style="width:40%;height:30px"
              :label="item.id"
              v-for="(item, index) in assessTypeData"
              :key="index"
              @change="riskTypeIdChange"
            >
              <el-input
                v-model="item.typeName"
                size="small"
                clearable
                :maxlength="12"
                style="width:90%"
              ></el-input>
            </el-radio>
          </el-radio-group>
          <el-checkbox-group v-model="checkList" v-else>
            <el-checkbox
              :label="item.id"
              v-for="(item, index) in assessTypeData"
              :key="index"
              >{{ item.typeName }}</el-checkbox
            >
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="检查对象:" v-if="ruleForm.assessType == 0">
          <el-input
            v-model="targetsValue"
            size="small"
            clearable
            :maxlength="20"
            style="width:80%"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="targetsSearch"
            ></el-button>
          </el-input>
          <el-checkbox-group v-model="targetsList">
            <el-checkbox
              v-show="isSearch"
              style="width:40%;height:30px"
              v-for="(item, index) in newTargetsData"
              :label="item.index"
              :key="item.index"
              ><el-input
                v-model="newTargetsData[index].label"
                size="small"
                clearable
                :maxlength="20"
                style="width:90%"
              ></el-input
            ></el-checkbox>
            <el-checkbox
              v-show="!isSearch"
              style="width:40%;height:30px"
              v-for="(item, index) in targetsData"
              :label="item.index"
              :key="item.index"
              ><el-input
                v-model="targetsData[index].label"
                size="small"
                clearable
                :maxlength="20"
                style="width:90%"
              ></el-input
            ></el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
    </div>
    <div class="save-or-cencel-box">
      <el-button size="small" @click="handleClose">取消</el-button>
      <el-button type="primary" size="small" @click="saveClick" v-loading="saveLoading">提交</el-button>
    </div>
  </el-dialog>
</template>

<script>
//这里可以引入其他文件（比如组件，工具js，第三方插件js，json文件，图片文件等等）
//列如：import <<组件名称>> from '《组件路径》';
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  props: {
    showDialog: {
      type: Boolean,
      default: () => {
        return false;
      }
    }
  },
  data() {
    //这里存放数据
    return {
      show: false,
      ruleForm: {
        schoolId: this.$store.state.schoolId,
        assessType: 0,
        riskTypeInfo: []
      },
      rules: {},
      oldAssessTypeData: [], //旧的风险类型数据
      assessTypeData: [],
      riskTypeId: "",
      checkList: [],
      targetsData: [], //检查对象
      oldTargetsData: [],
      targetsList: [],
      targetsValue: "", //筛选条件
      newTargetsData: [],
      isSearch: false,
      saveLoading:false
    };
  },
  //监控data中的数据变化
  watch: {
    showDialog: function(val) {
      this.show = val;
      this.riskTypeId = this.assessTypeData[0].id;
      this.riskTypeIdChange(this.riskTypeId);
      this.checkList = [];
      this.targetsList = [];
    }
  },
  //计算属性，类似于data概念
  computed: {
    //   评估类型
    assessmentType() {
      return this.$store.state.select.assessmentType;
    }
  },
  //方法集合
  methods: {
    handleClose(isRefresh) {
      this.$emit("close", isRefresh);
    },
    async assessTypeChange(val) {
      if (val == 0) {
        this.checkList = [];
      } else {
        this.riskTypeId = "";
        this.targetsData = [];
        this.targetsList = [];
      }
      let res = await this.$Http.getRiskList({ assessType: val });
      if (res.code == 200) {
        let data = res.data || [];
        this.assessTypeData = data;
        this.oldAssessTypeData = JSON.parse(JSON.stringify(data));
        this.riskTypeId = this.assessTypeData[0].id;
        this.riskTypeIdChange(this.riskTypeId);
      } else {
        this.assessTypeData = [];
        this.oldAssessTypeData = [];
      }
    },
    // 检查对象
    async riskTypeIdChange(val) {
      this.targetsValue = "";
      let res = await this.$Http.riskModelTargets({ riskTypeId: val });
      if (res.code == 200) {
        let data = res.data || [];
        let list = data.map((item, index) => {
          return {
            label: item,
            index: index
          };
        });
        this.targetsData = list;
        this.oldTargetsData = JSON.parse(JSON.stringify(list));
        this.targetsList = [];
      } else {
        this.targetsData = [];
        this.oldTargetsData = [];
      }
    },
    saveClick() {
      if (this.ruleForm.assessType == 0) {
        // LS
        if (this.targetsList.length == 0) {
          this.$message({
            type: "warning",
            message: "请先选择检查对象!"
          });
          return;
        }
        this.saveLoading = true
        let objc = {
          schoolId: this.$store.state.schoolId,
          assessType: this.ruleForm.assessType,
          riskTypeInfo: []
        };
        let riskTypeObj = {
          riskTypeId: this.riskTypeId,
          oldRiskTypeName: "",
          newRiskTypeName: "",
          inspectTargetInfos: []
        };
        let oldRiskType = this.oldAssessTypeData.find((item, index) => {
          return item.id == this.riskTypeId;
        });
        let newRiskType = this.assessTypeData.find((item, index) => {
          return item.id == this.riskTypeId;
        });
        riskTypeObj.oldRiskTypeName = oldRiskType.typeName;
        riskTypeObj.newRiskTypeName = newRiskType.typeName;
        let self = this;
        riskTypeObj.inspectTargetInfos = this.targetsList.map((item, index) => {
          let obj = {
            oldInspectTarget: self.oldTargetsData[item].label,
            newInspectTarget: self.targetsData[item].label
          };
          return obj;
        });
        objc.riskTypeInfo.push(riskTypeObj);
        this.addRiskModel(objc);
      } else {
        if (this.checkList.length == 0) {
          this.$message({
            type: "warning",
            message: "请先选择风险类型!"
          });
          return;
        }
        // LEC
        let objc = {
          schoolId: this.$store.state.schoolId,
          assessType: this.ruleForm.assessType,
          riskTypeInfo: []
        };
        console.log(this.checkList);
        objc.riskTypeInfo = this.checkList.map((item, index) => {
          let obj = {
            riskTypeId: item
          };
          return obj;
        });
        this.addRiskModel(objc);
      }
    },
    async addRiskModel(info) {
      let req = Object.assign({}, info);
      let res = await this.$Http.addRiskModel(req);
      this.saveLoading = false
      if (res.code == 200) {
        this.handleClose(true);
      } else {
      }
    },
    targetsSearch() {
      if (this.targetsValue) {
        this.isSearch = true;
        this.newTargetsData = [];
        this.targetsData.forEach((item, index) => {
          let label = item.label;
          if (label.indexOf(this.targetsValue) != -1) {
            this.newTargetsData.push(item);
          }
        });
      } else {
        this.isSearch = false;
        this.targetsList.forEach((item, index) => {
          this.targetsData[item.index] = item.label;
        });
        this.targetsList = this.targetsList.map((item, index) => {
          return item.label || item;
        });
      }
      // console.log(this.targetsValue)
    }
  },
  //生命周期，创建完成（可以访问当前this实例）
  created() {},
  //生命周期，挂载完成（可以访问dom元素）
  mounted() {
    this.assessTypeChange(0);
  },
  beforeCreate() {}, //生命周期-创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之后
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroy() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.dialog-box {
  width: 100%;
  height: 500px;
  overflow-y: scroll;
}
.save-or-cencel-box {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
</style>
